var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModel),expression:"showModel"}],staticClass:"common-popup",on:{"click":_vm.maskClick}},[_c('div',{staticClass:"common-box",class:_vm.position},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }